"use client"

import TransactionsView from "@/components/SwapHistory/TransactionsView";

export default function TransactionsPage() {
    return <TransactionsView />;
}
